import { TableColumn } from "react-data-table-component";
import { TopicPartQuestion } from "../../../../core/topicPartQuestion/entities/TopicPartQuestion";
import { TranslationFunction } from "../../../../utils/utils";

const answerTypeOptions = {
  text: "topicPartQuestion.answerType.text",
  singleChoice: "topicPartQuestion.answerType.singleChoice",
  multipleChoice: "topicPartQuestion.answerType.multipleChoice",
  yesNo: "topicPartQuestion.answerType.yesNo",
  yesNoUnknown: "topicPartQuestion.answerType.yesNoUnknown",
};
const topicPartQuestionColumns = (
  t: TranslationFunction
): TableColumn<TopicPartQuestion>[] => [
  {
    name: "topicPartQuestion.field.rank",
    width: "60px",
    selector: (row: TopicPartQuestion) => row.rank ?? 0,
  },
  {
    name: "topicPartQuestion.field.text",
    cell: (row: TopicPartQuestion) => (
      <div className="py-3 pointer-events-none">
        <p>{row.text}</p>
        <ul className="list-disc pl-4 ml-4 mt-1 opacity-50">
          {row.answers?.map((answer) => (
            <li key={answer}>{answer}</li>
          ))}
        </ul>
      </div>
    ),
    wrap: true,
  },
  {
    name: "topicPartQuestion.field.type",
    width: "150px",
    selector: (row: TopicPartQuestion) =>
      t(
        row.answerType in answerTypeOptions
          ? answerTypeOptions[row.answerType]
          : ""
      ),
  },
];

export default topicPartQuestionColumns;
